import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [RouterModule],
  template: `
      <div class="w-full h-full flex justify-center items-center">
        <div class="flex flex-col justify-center items-center bg-zinc-100 border-2 border-zinc-200 rounded-xl p-10">
          <i class="ri-lock-password-line text-5xl"></i>
          <h1 class="text-2xl font-semibold mt-5">403 – Unauthorized</h1>
          <p class="text-sm text-zinc-500 mt-2">You do not have permission to access this page.</p>
          <div class="mt-5 flex gap-4">
            <button class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600" routerLink="/dashboard">Go to Dashboard</button>
            <button class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600" (click)="goBack()">Go Back</button>
          </div>
        </div>
      </div>
  `,
  styles: ``
})
export class unauthorizedComponent {
  goBack(): void {
    window.history.back();
  }
}
